module.exports = __webpack_public_path__ + "img/users2.6c1645fe.svg";